module.exports = __webpack_public_path__ + "static/media/icon-search-inactive.c7b222dc.svg";